import * as React from 'react';
import {Box} from '@mui/material';
import LinearProgress from '@mui/material/LinearProgress';
import styles from './loadingbar.module.scss'

export default function LoadingBar(prop: {color: string}): JSX.Element {
    return (
        <Box sx={{ width: '100%' }}>
            <LinearProgress 
            color='secondary'
            className={styles.LoadingBar} />
        </Box>
    );
};